import { Skeleton } from "@/components/ui/skeleton";

interface QuickStatsProps {
  yearBirdies: number;
  yearEagles: number;
  activeGamesCount: number;
  latestBirdie: { hole: number; course: string } | null;
  isLoading?: boolean;
}

const QuickStats = ({ yearBirdies, yearEagles, activeGamesCount, latestBirdie, isLoading = false }: QuickStatsProps) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 px-4 mb-5">
      <div className="bg-white rounded-xl px-2.5 py-2.5 shadow-sm border border-border/50 min-w-0">
        <p className="text-[10px] text-muted-foreground tracking-wide uppercase">Games</p>
        {isLoading ? (
          <Skeleton className="h-7 w-10 mt-0.5" />
        ) : (
          <p className="text-xl font-semibold text-forest mt-0.5">{activeGamesCount}</p>
        )}
        <p className="text-[10px] text-muted-foreground">active</p>
      </div>
      <div className="bg-white rounded-xl px-2.5 py-2.5 shadow-sm border border-border/50 min-w-0">
        <p className="text-[10px] text-muted-foreground tracking-wide uppercase">Birdies</p>
        {isLoading ? (
          <Skeleton className="h-7 w-10 mt-0.5" />
        ) : (
          <p className="text-xl font-semibold text-gold mt-0.5">{yearBirdies}</p>
        )}
        <p className="text-[10px] text-muted-foreground">this year</p>
      </div>
      <div className="bg-white rounded-xl px-2.5 py-2.5 shadow-sm border border-border/50 min-w-0">
        <p className="text-[10px] text-muted-foreground tracking-wide uppercase">Eagles</p>
        {isLoading ? (
          <Skeleton className="h-7 w-10 mt-0.5" />
        ) : (
          <p className="text-xl font-semibold text-amber-500 mt-0.5">{yearEagles}</p>
        )}
        <p className="text-[10px] text-muted-foreground">this year</p>
      </div>
      <div className="bg-white rounded-xl px-2.5 py-2.5 shadow-sm border border-border/50 min-w-0">
        <p className="text-[10px] text-muted-foreground tracking-wide uppercase">Latest</p>
        {isLoading ? (
          <Skeleton className="h-7 w-10 mt-0.5" />
        ) : latestBirdie ? (
          <>
            <p className="text-xl font-semibold text-gold mt-0.5">#{latestBirdie.hole}</p>
            <p className="text-[10px] text-muted-foreground truncate">{latestBirdie.course}</p>
          </>
        ) : (
          <>
            <p className="text-xl font-semibold text-muted-foreground/30 mt-0.5">&mdash;</p>
            <p className="text-[10px] text-muted-foreground">no birdies yet</p>
          </>
        )}
      </div>
    </div>
  );
};

export default QuickStats;
